import DropdownActionsWrapper from '@/components/probaworkflows_base_components/DropdownActionsWrapper/DropdownActionsWrapper.vue';
import NavigationBackButton from "@/components/probaworkflows_base_components/NavigationBackButton/NavigationBackButton.vue";
import {
    ASSIGN_ENTITY_TYPES_URL,
    ASSIGN_SUB_ENTITY_URL,
    ASSIGNED_ENTITY_TYPES,
    CREATE_FORM,
    ENTITY_REGISTER,
    GET_ALL_FORM_TYPES,
    GET_ASSIGNED_SUB_ENTITIES_URL,
    GET_FORMS,
    get_headers,
    UNASSIGN_ENTITY_TYPES_URL,
    UNASSIGN_SUB_ENTITY_URL,
    UPDATE_FORM,
    VIEW_ENTITY_TYPE_URL,
} from '@/utils/constants/constants.js';
import alert_mixin from '@/utils/mixins/alert_mixin';
import formatting_mixins from "@/utils/mixins/formatting_mixins";
import { validate_non_empty_string, validate_non_sub_zero_number } from '@/utils/validations/validate_inputs';
import axios from 'axios';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import $ from 'jquery';

export default {
    name: 'FormManagement',
    components:{
        DropdownActionsWrapper,
        NavigationBackButton
    },
    mixins: [alert_mixin, formatting_mixins],
    data: () => ({
        headers: get_headers(),
        project_id: sessionStorage.getItem('project_id'),
        forms: [],
        trust_types: [],
        table_safe_trust_types: [],
        editing_form: null,
        current_form: {
            form_name: '',
            form_description: '',
            fields: []
        },
        dataTable: null,
        form_table_headers: [],
        table_safe_form_list: [],
        trustTypesDataTable: null,
        selected_entity_type_id: null,
        assigned_entity_dropdown_list: [],
        form_types: [],
    }),
    computed: {
        selected_types() {
            return this.table_safe_trust_types.filter(type => type.selected);
        }
    },
    mounted() {
        this.get_forms();
        this.ensure_form_types_loaded();
    },
    methods: {
        redirect_to_create_entity(form) {
            sessionStorage.setItem('form_id', form.id);
            sessionStorage.setItem('form_type', form.form_type_name || '');
            this.$router.push({
                path: '/create_entity',
                query: { form_id: form.id }
            });
        },

        async selected_share_form_id(form_id) {
            this.selected_form_id = form_id;
            this.selected_entity_type_id = null;
            try {

                const assigned_entity_types = await this.get_assigned_entity_types(form_id);
                this.assigned_entity_dropdown_list = assigned_entity_types.map(type => ({
                    id: type.id,
                    name: type.entity_type_name || type.name
                }));

                if (this.assigned_entity_dropdown_list.length > 0) {
                    this.selected_entity_type_id = this.assigned_entity_dropdown_list[0].id;
                }

                const sub_forms = await this.get_assigned_sub_entities(form_id);

                this.sub_entity_forms = sub_forms.map(sub => ({
                id: sub.id,
                form_name: sub.sub_entity_name || "Unnamed Sub-Form",
                description: sub.description || "—"
                }));

            } catch (error) {
                this.assigned_entity_dropdown_list = [];
                this.selected_entity_type_id = null;
                this.sub_entity_forms = [];
            }
        },


        initialize_data_table() {
            this.$nextTick(() => {
                const table_id = '#forms_table';
                const table = $(table_id);

                if (table.length === 0) {
                    return;
                }

                // Destroy the existing DataTable instance if it exists
                if ($.fn.DataTable.isDataTable(table)) {
                    table.DataTable().clear().destroy();
                }

                // Store the DataTable instance
                this.dataTable = table.DataTable({
                    responsive: true,
                    autoWidth: false,
                    pageLength: 10
                });
            });
        },

        initialize_trust_types_data_table() {
            this.$nextTick(() => {
                const table = $('#trust_types_table');

                if (!table.length || !table[0]) {
                    return;
                }

                const rows = table.find('tbody tr');
                if (rows.length === 0) {
                    return;
                }

                if ($.fn.DataTable.isDataTable(table)) {
                    table.DataTable().clear().destroy();
                }

                this.trustTypesDataTable = table.DataTable({
                    responsive: true,
                    autoWidth: false,
                    pageLength: 5,
                });

            });
        },


        destroy_trust_types_data_table() {
            if (this.trustTypesDataTable) {
                this.trustTypesDataTable.destroy();
                this.trustTypesDataTable = null;
            }
        },


        destroy_data_table() {
            if (this.dataTable) {
                this.dataTable.destroy();
                this.dataTable = null;
            }
        },

        async open_edit_modal(form) {
            this.editing_form = form;

            // Make sure types exist before we bind v-model
            await this.ensure_form_types_loaded();

            this.current_form = {
                id: form.id,
                form_name: form.name || form.form_name,
                form_description: form.description || form.form_description,
                // prefer object if present, else primitive
                form_type_id: form.form_type?.id ?? form.form_type_id ?? null,
            };

            // If the form had no type (edge case), preselect the first available
            if (!this.current_form.form_type_id && this.form_types.length) {
                this.current_form.form_type_id = this.form_types[0].id;
            }
        },


        // add under methods:
        async ensure_form_types_loaded() {
            if (Array.isArray(this.form_types) && this.form_types.length) return; // already loaded
            try {
                const { data } = await axios.get(GET_ALL_FORM_TYPES, { headers: this.headers });
                if (data?.status === 'success') {
                this.form_types = data.data || [];
                } else {
                this.form_types = [];
                this.show_error('Failed to load form types.');
                }
            } catch (err) {
                this.form_types = [];
                this.show_error('Failed to load form types: ' + (err.response?.data?.message || err.message));
            }
        },


        async open_create_modal() {
            this.current_form = {
                form_name: '',
                form_description: '',
                form_type_id: null,
                fields: []
            };

            try {
                const response = await axios.get(GET_ALL_FORM_TYPES, {
                    headers: this.headers
                });
                const result = response.data;
                if (result.status === 'success') {
                    this.form_types = result.data;
                    if (this.form_types.length > 0) {
                        this.current_form.form_type_id = this.form_types[0].id; // pre-select first
                    }
                }
            } catch (error) {
                this.show_error("Failed to load form types: " + (error.response?.data?.message || error.message));
            }
        },



        async open_assign_modal(form) {
            this.current_form = {
                id: form.id,
                form_name: form.form_name,
                form_description: form.form_description,
                fields: form.fields || []
            };

            this.destroy_trust_types_data_table();

            try {
                await this.get_trust_types(false);

                const [assigned_entity_types, assigned_sub_entities] = await Promise.all([
                    this.get_assigned_entity_types(form.id),
                    this.get_assigned_sub_entities(form.id)
                ]);

                const assigned_entity_ids = assigned_entity_types.map(item => item.id);
                const assigned_sub_ids = assigned_sub_entities.map(item => item.id);

                // Mark selected entity types
                this.table_safe_trust_types.forEach(type => {
                    type.selected = assigned_entity_ids.includes(type.id);

                    // Mark selected sub-entities under this type
                    if (Array.isArray(type.sub_entities)) {
                        type.sub_entities.forEach(sub => {
                            sub.selected = assigned_sub_ids.includes(sub.id);
                        });
                    }
                });

                this.$nextTick(() => {
                    this.initialize_trust_types_data_table();
                });

            } catch (error) {
                const message = error.response?.data?.message || error.message;
                this.show_error("Failed to open assign modal: " + message);
            }
        },


        create_forms() {
            if (!validate_non_empty_string(this.current_form.form_name)) {
                this.show_error('Form name is required.');
                return;
            }

            if (this.current_form.form_description !== '') {
                if (!validate_non_empty_string(this.current_form.form_description)) {
                    this.show_error('Form description is required.');
                    return;
                }
            }

            const payload = {
                ...this.current_form,
                project_id: this.project_id
            };

            axios.post(CREATE_FORM, payload, { headers: this.headers })
                .then(response => {
                    const response_data = JSON.parse(response.data);
                    const { status, message } = response_data;
                    if (status === 'success') {
                        this.close_modal('create_form');
                        this.show_success('Entity form created successfully.');
                        window.location.reload();
                    } else {
                        this.show_error('Error creating form: ' + (message || 'Unknown error'));
                        this.close_modal('create_form');
                    }
                })
                .catch(error => {
                    this.show_error('Error creating form: ' + (error.response?.data?.message || 'An unexpected error occurred'));
                    this.close_modal('create_form');
                });
        },


        async get_trust_types(initialize_table = false) {
            const project_id = parseInt(this.project_id, 10);

            if (!validate_non_sub_zero_number(project_id)) {
                this.show_error('Project Id must not be null');
                return;
            }

            try {
                const response = await axios.get(VIEW_ENTITY_TYPE_URL, {
                    headers: this.headers,
                    params: { project_id }
                });

                const response_data = response.data;
                if (response_data.status === 'success') {
                    this.trust_types = response_data.data;
                    this.transform_trust_types_data(initialize_table);
                } else {
                    this.show_error('Error entity types retrieval');
                }
            } catch (error) {
                this.show_error('Error entity types retrieval: ' + (error.response?.data?.message || error.message));
            }
        },


        transform_trust_types_data(initialize_table = false) {
            if (this.trust_types.length > 0) {
                this.table_safe_trust_types = this.trust_types.map(type => ({
                    id: type.id,
                    entity_type_name: type.entity_type_name,
                    entity_type_description: type.entity_type_description,
                    selected: false,
                    is_active: type.is_active,
                    date_created: type.date_created,
                    sub_entities: Array.isArray(type.sub_entities)
                        ? type.sub_entities.map(sub => ({
                            id: sub.id,
                            sub_entity_name: sub.sub_entity_name,
                            description: sub.description,
                            selected: false,
                            date_created: sub.date_created
                        }))
                        : []
                }));


                this.$nextTick(() => {
                    if (initialize_table) {
                        this.initialize_trust_types_data_table();
                    }
                });
            }
        },



        get_forms() {
            this.destroy_data_table();
            this.forms = [];

            var query_params = {
                project_id: this.project_id,
            };

            axios.get(GET_FORMS, {
                headers: this.headers,
                params: query_params
            })
            .then(response => {
                const parsed_response = JSON.parse(response.data);
                if (parsed_response.data && parsed_response.data.length > 0) {
                    this.forms = parsed_response.data;
                    this.transform_forms_data();
                } else {
                    this.forms = [];
                }
            })
            .catch(error => {
                this.show_error('Error getting forms: ' + (error.response?.data?.message || error.message));
                this.forms = [];
            });
        },


        transform_forms_data() {
            if (this.forms.length > 0) {
                const TABLE_FORM_DATA = this.forms.map(form => ({
                    "id": form.id,
                    "name": form.form_name,
                    "description": form.form_description,
                    "last_modified": this.format_date(form.last_modified || form.date_created),
                    "status": form.status,
                    "date_created": form.date_created,
                    "form_type_id": form.form_type.id,
                    "form_type_name": form.form_type.form_type,
                }));
                this.form_table_headers = Object.keys(TABLE_FORM_DATA[0]);
                this.table_safe_form_list = TABLE_FORM_DATA;
            }
            this.$nextTick(() => {
                this.initialize_data_table();
            });

        },


        update_form() {
            if (!validate_non_empty_string(this.current_form.form_name)) {
                this.show_error('Form name is required.');
                return;
            }
            if (this.current_form.form_description !== '' &&
                !validate_non_empty_string(this.current_form.form_description)) {
                this.show_error('Form description is required.');
                return;
            }
            if (!validate_non_sub_zero_number(this.current_form.form_type_id)) {
                this.show_error('Please choose a valid form type.');
                return;
            }

            const payload = {
                form_id: this.current_form.id,
                form_name: this.current_form.form_name,
                form_description: this.current_form.form_description,
                form_type_id: this.current_form.form_type_id,
            };

            axios.post(UPDATE_FORM, payload, { headers: this.headers })
                .then(response => {
                const response_data = JSON.parse(response.data);
                const { status, message } = response_data;
                if (status === 'success') {
                    this.close_modal('edit_form');
                    this.get_forms(); // refresh list
                    this.show_success('Entity form updated successfully.');
                } else {
                    this.show_error('Error updating form: ' + (message || 'Unknown error'));
                    this.close_modal('edit_form');
                }
                })
                .catch(error => {
                this.show_error('Error updating form: ' + (error.response?.data?.message || 'An unexpected error occurred'));
                this.close_modal('edit_form');
                });
        },


        get_selected_sub_entities() {
            const selected_subs = [];

            for (const type of this.table_safe_trust_types) {
                if (Array.isArray(type.sub_entities)) {
                for (const sub of type.sub_entities) {
                    if (sub.selected) {
                    selected_subs.push(sub.id);
                    }
                }
                }
            }

            return selected_subs;
        },

        async save_assignment() {
            if (!this.current_form.id) {
                this.show_error("Form ID is missing");
                return;
            }

            const form_id = this.current_form.id;
            const selected_type_ids = this.selected_types.map(t => t.id);
            const selected_sub_ids = this.get_selected_sub_entities();

            try {
                const [
                    assigned_entity_types,
                    assigned_sub_entities
                ] = await Promise.all([
                    this.get_assigned_entity_types(form_id),
                    this.get_assigned_sub_entities(form_id)
                ]);

                const current_type_ids = assigned_entity_types.map(t => t.id);
                const current_sub_ids = assigned_sub_entities.map(s => s.id);

                const to_assign_types = selected_type_ids.filter(id => !current_type_ids.includes(id));
                const to_unassign_types = current_type_ids.filter(id => !selected_type_ids.includes(id));

                const to_assign_subs = selected_sub_ids.filter(id => !current_sub_ids.includes(id));
                const to_unassign_subs = current_sub_ids.filter(id => !selected_sub_ids.includes(id));

                const [
                    assign_msg,
                    unassign_msg,
                    assign_sub_msg,
                    unassign_sub_msg
                ] = await Promise.all([
                    this.assign_entity_types(form_id, to_assign_types),
                    this.unassign_entity_types(form_id, to_unassign_types),
                    this.assign_sub_entities(form_id, to_assign_subs),
                    this.unassign_sub_entities(form_id, to_unassign_subs)
                ]);

                const messages = [assign_msg, unassign_msg, assign_sub_msg, unassign_sub_msg].filter(Boolean);
                if (messages.length === 0) {
                    this.show_info("No changes were made.");
                    return;
                }

                this.show_success(messages.join(" "));
                this.close_modal('assign_form');

            } catch (error) {
                const msg = error.response?.data?.message || error.message || "Unexpected error";
                this.show_error("Error saving assignment: " + msg);
            }
        },


        async assign_entity_types(form_id, entity_type_ids) {
            if (!Array.isArray(entity_type_ids) || entity_type_ids.length === 0) return null;

            try {
                await axios.post(ASSIGN_ENTITY_TYPES_URL, {
                    form_id,
                    entity_type_ids
                }, { headers: this.headers });

                return "Entity types assigned successfully.";
            } catch (error) {
                const msg = error.response?.data?.message || error.message || "Failed to assign entity types";
                this.show_error(msg);
                return null;
            }
        },

        async unassign_entity_types(form_id, entity_type_ids) {
            if (!Array.isArray(entity_type_ids) || entity_type_ids.length === 0) return null;

            try {
                await axios.post(UNASSIGN_ENTITY_TYPES_URL, {
                    form_id,
                    entity_type_ids
                }, { headers: this.headers });

                return "Entity types unassigned successfully.";
            } catch (error) {
                const msg = error.response?.data?.message || error.message || "Failed to unassign entity types";
                this.show_error(msg);
                return null;
            }
        },


        async assign_sub_entities(form_id, sub_entity_ids) {
            if (!Array.isArray(sub_entity_ids) || sub_entity_ids.length === 0) return null;

            try {
                await axios.post(ASSIGN_SUB_ENTITY_URL, {
                form_id,
                sub_entity_ids
                }, { headers: this.headers });

                return "Sub-entities assigned successfully.";
            } catch (error) {
                const msg = error.response?.data?.message || error.message || "Failed to assign sub-entities";
                this.show_error(msg);
                return null;
            }
            },

            async unassign_sub_entities(form_id, sub_entity_ids) {
            if (!Array.isArray(sub_entity_ids) || sub_entity_ids.length === 0) return null;

            try {
                await axios.post(UNASSIGN_SUB_ENTITY_URL, {
                form_id,
                sub_entity_ids
                }, { headers: this.headers });

                return "Sub-entities unassigned successfully.";
            } catch (error) {
                const msg = error.response?.data?.message || error.message || "Failed to unassign sub-entities";
                this.show_error(msg);
                return null;
            }
            },








        async share_trust_setup() {
            const form_id = parseInt(this.selected_form_id, 10);

            if (!validate_non_sub_zero_number(form_id)) {
                this.show_error('Please select a form to share');
                return;
            }

            if (!this.email || !this.email.includes('@')) {
                this.show_error('Please enter a valid email address');
                return;
            }

            const entity_type_id = this.selected_entity_type_id;
            if (!validate_non_sub_zero_number(entity_type_id)) {
                this.show_error('Please select an entity type');
                return;
            }

            try {
                const assigned_entity_types = await this.get_assigned_entity_types(form_id);
                const assigned_entity_ids = assigned_entity_types.map(et => et.id);

                if (!assigned_entity_ids.includes(entity_type_id)) {
                    this.show_error('This entity type is not assigned to the form. Please assign it first.');
                    return;
                }

                const payload = {
                    form_id,
                    email: this.email,
                    project_id: this.project_id,
                    entity_type_id
                };

                const share_response = await axios.post(ENTITY_REGISTER, payload, {
                    headers: this.headers
                });

                if (share_response.data) {
                    this.show_success('Entity form successfully shared.');
                    this.close_modal('share_trust_form');
                    this.email = '';
                }

            } catch (error) {
                const msg = error.response?.data?.message || error.message || "Something went wrong";
                this.show_error(msg);
                this.close_modal('share_trust_form');
            }
        },

        async get_assigned_entity_types(form_id) {
            const response = await axios.get(ASSIGNED_ENTITY_TYPES, {
                headers: this.headers,
                params: { form_id }
            });
            return response.data?.data || [];
        },

        async get_assigned_sub_entities(form_id) {
            const response = await axios.get(GET_ASSIGNED_SUB_ENTITIES_URL, {
                headers: this.headers,
                params: { form_id }
            });
            return response.data?.data || [];
        },

    }
}